import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import React, { Component }  from 'react';
import { LocalForm } from 'react-redux-form';
import Alert from '../../container/Alert';
import Header from '../Header';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import Spinner from '../Snowflake/as/Spinner';
const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'assessment.header.title',
    description: 'Page Header Title',
    defaultMessage: 'Free Assessment'
  },
  headerSubTitle: {
    id: 'assessment.header.subtitle',
    description: 'Page Header Subtitle',
    defaultMessage: 'Upload files for translation free assessment.'
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

const print = status => {
  if (status.payload) {
    // console.log(status.payload.response);
    return status.payload.response;
  }
};

// const ResultMsgPage = props => {
//   const { intl } = props;
  //const fileList = project.files;   // THIS IS OTHER time's comment not with construct

  class ResultMsgPage extends Component {

    constructor(props) {
      super(props);
      const { intl } = this.props;

      this.state ={
        show:true
      }
    }

    componentDidMount() {
      this.setState({show:false})
    }
render() {
  let showMsg;
  if (this.props.reference_id.length > 0) {
    showMsg =
      `Your Analyzer Report request has been submitted. This task’s reference ID is ${
      this.props.reference_id
      }. You will be notified via email once the Analyzer Report is generated.`;
  } else {
    showMsg =
      'Our system encountered technical difficulties during your request. Please submit your request again, or reach out to our support at <a href="mailto:shiftsupport@nextpathway.com">shiftsupport@nextpathway.com</a>. We are sorry for the inconvenience.';
  }

  return (
    <div className={this.state.show ?"pageHide": "page"}>
      <Helmet>
        <title>{this.props.intl.formatMessage(messages.htmlHeader)} - SHIFT</title>
      </Helmet>
      <Header
        title={this.props.intl.formatMessage(messages.headerTitle)}
        subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
        icon="preview"
        locale={this.props.locale}
      />

{this.state.show ? (
<div   style={{display:"block"}}>
         <Spinner />

</div>):null}

      <Alert
        title={this.props.intl.formatMessage(messages.htmlHeader)}
        message={print(this.props.status)}
      />
      <div className="main">
        <div
          className="panel"
          style={{
            width: '60%',
            padding: '40px',
            boxSizing: 'content-box',
            marginTop: '15px',
            display: 'block',
            alignContent: 'center',
            marginLeft: 'auto',
            marginRight: 'auto'
          }}
        >
          <LocalForm>
            <div className="form">
              <label
                style={{
                  width: '90%',
                  fontSize: '16px',
                  textTransform: 'none',
                  lineHeight: '150%',
                  color: '#797979'
                }}
              >
                {showMsg}
                <br />
              </label>

              <br />
              <br />
              <div className="button-container" style={{ textAlign: 'center' }}>
                <button
                  className="button"
                  styel={{ padding: 20 }}
                    onClick={() => {this.handleShow(), this.props.clickOKHandler()}}
                >
                  <FormattedMessage id="nav.ok" defaultMessage="OK" />
                </button>
              </div>
            </div>
          </LocalForm>
        </div>
      </div>
      <Footer />
    </div>
  )}

  handleShow(){
    this.setState({show:true})
  }
}

ResultMsgPage.propTypes = {};

export default injectIntl(ResultMsgPage);



// WEBPACK FOOTER //
// ./src/components/views/ResultMsgPage/index.js